import * as React from "react";
import { CennaLogo } from "../primitives/Avatar";
import { ProfileMenu } from "./ProfileMenu";

export type PluginHeaderProps = {
  title?: string;
  subtitle?: string;
  userName?: string;
  userEmail?: string;
  logoutPending?: boolean;
  onLogout?: () => void;
  onGoToPlatform?: () => void;
};

export const PluginHeader: React.FC<PluginHeaderProps> = ({
  title = "Cenna",
  subtitle,
  userName,
  userEmail,
  logoutPending,
  onLogout,
  onGoToPlatform,
}) => {
  return (
    <header className="plugin-header">
      <CennaLogo size={26} />
      <div className="plugin-header__text">
        <div className="plugin-header__title">{title}</div>
        {subtitle ? <div className="plugin-header__subtitle">{subtitle}</div> : null}
      </div>
      <div className="plugin-header__status">
        <span className="plugin-header__dot" aria-hidden />
        <span className="plugin-header__connected">Connected</span>
      </div>
      <ProfileMenu
        userName={userName}
        userEmail={userEmail}
        logoutPending={logoutPending}
        onLogout={onLogout}
        onGoToPlatform={onGoToPlatform}
      />
    </header>
  );
};
